/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Stack, Link, Icon } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { FontSizes } from '@uifabric/fluent-theme/lib/fluent/FluentType';

import { classes } from '../../utils';
import NavbarItemsList from './NavbarItemsList';
// import { NavbarItemslist } from '.';

// Inschuiven van links + zacht donker wordende achtergrond. Het menu blijft altijd in de DOM
// (display: none valt niet te animeren); verborgen = visibility hidden, dus niet klikbaar of
// focusbaar. Bij het sluiten wacht visibility tot de animatie gedaan is.
const DURATION = 240;
const EASE = 'cubic-bezier(0.2, 0.8, 0.2, 1)';
const reducedMotion = { '@media (prefers-reduced-motion: reduce)': { transition: 'none' } };
const anim = mergeStyleSets({
  root: {
    visibility: 'hidden',
    transition: `visibility 0s linear ${DURATION}ms`,
    selectors: reducedMotion,
  },
  rootOpen: { visibility: 'visible', transition: 'visibility 0s' },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    transition: `background-color ${DURATION}ms ease`,
    selectors: reducedMotion,
  },
  backdropOpen: { backgroundColor: 'rgba(0, 0, 0, 0.28)' },
  menu: {
    transform: 'translateX(-100%)',
    boxShadow: 'none',
    transition: `transform ${DURATION}ms ${EASE}, box-shadow ${DURATION}ms ease`,
    willChange: 'transform',
    selectors: {
      ...reducedMotion,
      // Eigen, minimale scrollbalk: dun, afgerond, zonder spoor; enkel zichtbaar bij hover.
      // Chromium/Safari via ::-webkit-scrollbar (geen scrollbar-color zetten: die heeft daar
      // voorrang en schakelt deze opmaak uit); Firefox via scrollbar-width/-color.
      '::-webkit-scrollbar': { width: 10 },
      '::-webkit-scrollbar-track': { background: 'transparent' },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: 'transparent',
        borderRadius: 999,
        // rand in de achtergrondkleur: zo oogt de balk 4px breed met wat lucht errond
        border: '3px solid transparent',
        backgroundClip: 'padding-box',
      },
      ':hover::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0, 0, 0, 0.18)' },
      '::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(0, 0, 0, 0.32)' },
      '::-webkit-scrollbar-thumb:active': { backgroundColor: 'rgba(0, 0, 0, 0.4)' },
      '@supports (-moz-appearance: none)': {
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(0, 0, 0, 0.22) transparent',
      },
    },
  },
  menuOpen: { transform: 'translateX(0)', boxShadow: '4px 0 24px rgba(0, 0, 0, 0.12)' },
});

interface INavigation {
  show: boolean;
  headerHeight: number;
  toggleNavigation: () => void;
  onNavigate?: (path: string) => void;
}

const Navigation = ({
  show, headerHeight, toggleNavigation, onNavigate,
}: INavigation) => (
  <div
    className={`${classes.navigation} ${anim.root} ${show ? anim.rootOpen : ''}`}
    aria-hidden={!show}
  >
    <div
      className={`${classes.dismiss} ${anim.backdrop} ${show ? anim.backdropOpen : ''}`}
      onClick={() => toggleNavigation()}
      style={{ pointerEvents: show ? 'auto' : 'none' }}
    >
      <Stack className={`${classes.menu} ${anim.menu} ${show ? anim.menuOpen : ''}`}>
        <Stack>
          <Stack.Item
            className={`${classes.toggleButton} test`}
            align='stretch'
            styles={{ root: { minHeight: `${headerHeight}px` } }}
          >
            <Link
              className={classes.innerItem}
              onClick={toggleNavigation}
              style={{ display: 'block', fontSize: FontSizes.size18 }}
            >
              <Icon iconName='GlobalNavButton' className={classes.icon} />
            </Link>
          </Stack.Item>
          <NavbarItemsList onNavigate={onNavigate} />
        </Stack>
      </Stack>
    </div>
  </div>
);

export default Navigation;
